<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>

    <v-flex>
      <app-upsert
       title='New Request'
        :config="config"
        :item="disposed"
        @saved="saved"/>

    </v-flex>

  </v-container>
</template>

<script>

import config from './config_new.js'

export default {
  data ({ $store }) {
    let disposed = {}
    if ($store.getters.user.site_id) {
      disposed.site_id = $store.getters.user.site_id
    }
    if ($store.getters.app.protocol.id !== -1) {
      disposed.protocol_id = $store.getters.app.protocol.id
    }
    return {
      config,
      disposed
    }
  },
  methods: {
    saved ({ data }) {
      this.$router.push(`/disposed/${data.id}`)
    }
  }
}
</script>